class VideosAnchorHeaderFix
  adjustAnchor: ->
    $anchor = $(':target')
    fixedElementHeight = $('#header-wrap').height()
    if $anchor.length > 0
      window.scrollTo(0, $anchor.offset().top - fixedElementHeight)

  init: ->
    that = @
    $(window).on 'hashchange load', ->
      that.adjustAnchor()
    @adjustAnchor()

LP.VideosAnchorHeaderFix = VideosAnchorHeaderFix